<template>
  <div class="page">
    <div v-if="categoryIsLoad" class="category-main">
      <!-- 选择类目 -->
      <div class="category-item">
        <div class="category-key">选择类目:</div>
        <div class="category-val flex-column">
          <div class="category-input" @click="toggleCategory">
            <span>{{ categoryActiveStr }}</span>
            <el-link class="m-l-10" type="primary">
              {{ toggleStr }}
            </el-link>
          </div>
          <div v-show="isShowCategory" class="goods-category">
            <b-goods-category
              :ids="categoryRouteIds"
              :isInit="!categoryRouteIds.length"
              @success="getCategoryActiveList"
            />
          </div>
        </div>
      </div>

      <!-- 商品属性维护 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">商品属性维护:</div>
        <div class="category-val">
          <ModuleShuxing
            :list.sync="shuxingList"
            :obj="categoryLastActiveObj"
            @success="getModuleShuxingList"
          />
        </div>
      </div>

      <!-- 单位公式选择 -->
      <div v-if="categoryLastId" class="category-item">
        <div class="category-key">单位公式选择:</div>
        <div class="category-val">
          <ModuleUnit
            :list.sync="unitList"
            :obj="categoryLastActiveObj"
            @success="getModuleUnitList"
          />
        </div>
      </div>

      <!-- 库存列表 -->
      <ModuleGoods v-if="categoryLastId" ref="refModuleGoods" :categoryLastId="categoryLastId" />
    </div>
  </div>
</template>

<script>
import ModuleShuxing from './common/module-shuxing'
import ModuleUnit from './common/module-unit'
import ModuleGoods from './common/module-goods'
export default {
  components: {
    ModuleShuxing,
    ModuleUnit,
    ModuleGoods
  },
  data() {
    return {
      // 类目
      isShowCategory: false,
      categoryIsLoad: false,
      categoryLastId: '',
      categoryRouteIds: [],
      categoryActiveList: [],

      // 模块
      isLoadShuxing: false,
      isLoadUnit: false,
      shuxingList: [], // 属性
      unitList: [] // 单位
    }
  },
  computed: {
    // 类目末级选中对象
    categoryLastActiveObj() {
      let result = ''
      let len = this.categoryActiveList.length
      if (len) result = this.categoryActiveList[len - 1]
      return result
    },
    // 类目选中字符串
    categoryActiveStr() {
      let result = ''
      let listName = this.categoryActiveList.map((item) => item.name)
      result = listName.join('/')
      return result // 类目名称拼接成字符串
    },
    // 切换字符串
    toggleStr() {
      let result = this.isShowCategory ? '收起↑' : '展开↓'
      return result
    },
    // 提示字符串
    promptStr() {
      let result = `${this.categoryActiveStr}（点击${this.toggleStr}）`
      return result
    },
    // 是否更新表格配置
    isUpdateTableOptions() {
      return this.isLoadShuxing && this.isLoadUnit
    }
  },
  watch: {
    categoryLastActiveObj(newVal, oldVal) {
      if (newVal.id !== oldVal.id) {
        if (newVal.has_children) {
          this.categoryLastId = ''
        } else {
          this.categoryLastId = newVal.id
          this.isShowCategory = false
          this.$nextTick(() => {
            this.initModuleData()
          })
        }
      }
    },
    isUpdateTableOptions(val) {
      if (val) {
        this.$refs.refModuleGoods.initTableOptions()
      }
    }
  },
  mounted() {
    this.getCategoryRouteIds()
  },
  methods: {
    // 切换类目
    toggleCategory() {
      this.isShowCategory = !this.isShowCategory
    },
    // 获取路由类目ids
    getCategoryRouteIds() {
      this.categoryIsLoad = false
      let idsStr = this.$route.query.ids
      let idsList = []
      if (idsStr) idsList = idsStr.split(',')
      this.categoryRouteIds = idsList.map((item) => Number(item))
      this.categoryIsLoad = true
    },
    // 获取选中类目列表
    getCategoryActiveList(list) {
      this.categoryActiveList = []
      list.forEach((itemSt) => {
        itemSt.category.forEach((itemNd) => {
          if (itemSt.title.active_id === itemNd.id) {
            this.categoryActiveList.push(this.$util.deepCopy(itemNd))
          }
        })
      })
    },
    // 初始化模块数据
    initModuleData() {
      this.getModuleShuxingList()
      this.getModuleUnitList()
    },
    // 获取模块-属性列表
    getModuleShuxingList() {
      this.isLoadShuxing = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/dict/listColumn',
        params: {
          column_data_id: this.categoryLastId
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.shuxingList = res.data.list
          }
        })
        .catch(() => {})
        .then(() => {
          this.isLoadShuxing = true
        })
    },
    // 获取模块-单位列表
    getModuleUnitList() {
      this.isLoadUnit = false
      this.$api({
        method: 'get',
        url: '/admin/gcvip/columnDataJiSuanGongShi/list',
        params: {
          id: this.categoryLastId
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.unitList = res.data.list
          }
        })
        .catch(() => {})
        .then(() => {
          this.isLoadUnit = true
        })
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  padding-bottom: 10px;
  .category-main {
    .category-item {
      position: relative;
      display: flex;
      z-index: 99;
      & ~ .category-item {
        margin-top: 5px;
        z-index: 9;
      }
      .category-key {
        width: 107px;
        padding: 5px 5px 5px 0;
        line-height: 28px;
        text-align: right;
        background: #f8f8f9;
        border: 1px solid #e4e7ed;
        border-radius: 2px 0 0 2px;
      }
      .category-val {
        position: relative;
        min-width: 805px;
        padding: 5px;
        margin-left: -1px;
        border: 1px solid #e4e7ed;
        border-radius: 0px 2px 2px 0;
        .category-input {
          display: flex;
          align-items: center;
          width: 793px;
          height: 26px;
          padding: 0 5px;
          border: 1px solid #ddd;
          border-radius: 2px;
          cursor: pointer;
        }
        .goods-category {
          position: absolute;
          top: 32px;
          left: 5px;
          display: flex;
        }
      }
    }
  }

  /deep/ .vxe-table--body-wrapper {
    min-height: 30px !important;
  }

  /deep/ .row--hover {
    background: @colorBlue10;
  }
}
</style>
